import React from 'react';
import { Rocket } from 'lucide-react';

export const Loading = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px]">
      <div className="relative">
        <Rocket className="w-16 h-16 text-[#00C2CB] animate-bounce" />
        <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-[#FF6B00]/30 rounded-full blur-md animate-pulse"></div>
      </div>
      <p className="mt-6 text-[#1A1A2E] font-fredoka font-bold text-lg">Cargando...</p>
    </div>
  );
};